import { useCallback, useEffect, useImperativeHandle, useState } from "react";
function useActionBar(params) {
  const { actions, onChanged, buttonRef, onClick } = params;
  const [open, setOpen] = useState(false);
  const onOpen = useCallback(
    (e) => {
      e.stopPropagation();
      setOpen(buttonRef?.current !== null);
    },
    [buttonRef]
  );
  const openApi = useCallback(() => {
    setOpen(buttonRef?.current !== null);
  }, [buttonRef]);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  const toggleApi = useCallback(() => {
    setOpen((prevOpenState) => buttonRef.current !== null ? !prevOpenState : false);
  }, [buttonRef]);
  useEffect(() => onChanged?.(open), [open, onChanged]);
  useImperativeHandle(
    actions,
    () => ({
      open: openApi,
      close: onClose,
      toggle: toggleApi
    }),
    [onClose, openApi, toggleApi]
  );
  const menuOpen = buttonRef.current !== null && open;
  const parentOnClick = (item) => {
    onClick?.(item);
    onClose();
  };
  return {
    menuOpen,
    onOpen,
    onClose,
    parentOnClick
  };
}
export {
  useActionBar
};
//# sourceMappingURL=useActionBar.js.map
